module.exports = __webpack_public_path__ + "static/media/WEBnegro_18.e14d1c57.png";